import React from 'react';
import {
  Paper,
  Modal,
  Backdrop,
  Fade,
  Button,
  Grid,
  Tooltip,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from "react-router";

import {
  calculateFlagSeverity,
  calculateFlagColorsBasedOnSeverity,
  makeProper
} from '../../../../utils/functions';

import './QuestPreapproval.scss';

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
    '&:focus': {
      outline: 'none',
    },
  },
  paper: {
    backgroundColor: '#212227',
    boxShadow: theme.shadows[5],
    color: 'white',
    width: '480px',
    maxWidth: '90%',
  },
  topMast: {
    backgroundColor: '#313337',
    padding: '20px 40px',
  },
  mainContainer: {
    width: '100%',
    height: '100%',
    padding: '40px 40px',
  },
  textField: {
    boxShadow: 'none !important',
    '-webkit-appearance': 'none',
  },
  errorButton: {},
  confirmButton: {
    backgroundColor: 'green',
  },
  buttonGrid: {
    width: '100%',
    marginTop: '30px',
  },
  inputBox: {
    lineHeight: 2,
  },
  warning: {
    color: 'red',
    marginTop: '20px',
  },
  openButton: {
    color: 'white',
    cursor: 'pointer',
    width: '100%',
    height: '100%',
    padding: '5px 10px',
  },
}));

export default function CampaignFlag(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const {
    campaignFlag,
    styling,
    tooltipTitle,
  } = props;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const btn = (
    <Tooltip title={tooltipTitle} placement='top'>
      <button type='button' className='small-btn' onClick={handleOpen}>
        <i
          className="fa fa-flag"
          style={styling}
        />
      </button>
    </Tooltip>
  );

  const campaignQuests = campaignFlag.map(cf => {
    const { gameId, questTitle, questId, status } = cf;
    const severity = calculateFlagSeverity(cf);
    const color = calculateFlagColorsBasedOnSeverity(severity);

    return (
      <TableRow
        key={`${gameId}-${questId}`}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableCell component="th" scope="row">
          {questTitle}
        </TableCell>
        <TableCell style={{ color: color }}>{makeProper(status)}</TableCell>
        <TableCell>
          <Tooltip title="Preapproval" placement="top">
            <Link
              to={`/admin/command-center/${gameId}/quests/${questId}/preapproval`}
              activeClassName="active"
              href={`/admin/command-center/${gameId}/quests/${questId}/preapproval`}
              className="remove-key"
              target='_blank'
            >
              <i className='fa fa-external-link' />
            </Link>
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  })

  return (
    <div className="CampaignFlag">
      {btn}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Paper className={classes.paper}>
            <Grid
              xs={12}
              container
              direction="column"
              justify="flex-start"
              alignItems="flex-start"
            >
              <Grid container xs={12} justify="space-around" align="flex-start" direction="column" className={classes.mainContainer}>
                <TableContainer component={Paper}>
                  <Table aria-label="campaign flag table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Quest</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Link</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {campaignQuests}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Grid
                  container
                  className={classes.buttonGrid}
                  xs={12}
                  direction="row"
                  width="100%"
                  justify="space-between"
                  alignItems="right"
                >
                  <Grid>
                    <Button
                      onClick={handleClose}
                      className={classes.errorButton}
                    >
                      Close
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Fade>
      </Modal>
    </div>
  );
}
